module.exports = __webpack_public_path__ + "img/currency_exchange.d46423c2.svg";